<h1 mat-dialog-title class="text-center" *ngIf="info">ALERT</h1>

<div mat-dialog-content *ngIf="info">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12" class="text-center">
        <div *ngIf="info?.isBlockedByFamily || info?.isBlockedByFines || info?.isBlockedByOverdues">
          <p>Your account is being blocked due to:</p>
          <div *ngIf="info?.isBlockedByFamily" class="bold">Family</div>
          <br />
          <div *ngIf="info?.isBlockedByFamily">{{ info?.msgBlockedByFamily }}</div>

          <div *ngIf="info?.isBlockedByFines" class="bold">Outstanding Fines</div>
          <br />
          <div *ngIf="info?.isBlockedByFines">{{ info?.msgBlockedByFines }}</div>

          <div *ngIf="info?.isBlockedByOverdues" class="bold">Outstanding Overdues</div>
          <br />
          <div *ngIf="info?.isBlockedByOverdues">{{ info?.msgBlockedByOverdues }}</div>
        </div>

        <div *ngIf="summary !== ''" class="text-center">{{ summary }}</div>
      </div>
    </div>
  </div>
</div>

<div mat-dialog-actions class="float-end">
  <button role="button" type="button" aria-label="Yes" mat-button cdkFocusInitial (click)="close()">
    OK
  </button>
</div>
